import React, { Component } from 'react';
import SideMenuHome from '../../components/SideMenuHome/SideMenuHome';
import HomeBg from '../../components/HomeBg/HomeBg';
import styled from 'styled-components';
import InfoEarthnight from '../../components/InfoEarthnight/InfoEarthnight';
import CarouselExplore from '../../components/CarouselExplore/CarouselExplore';
import CarouselTrending from '../../components/CarouselTrending/CarouselTrending';
import CarouselActions from '../../components/CarouselActions/CarouselActions';
import {Link} from 'react-router-dom';

const Tree = styled.p`
  display:flex;
  flex-direction:row;
  flex-wrap:wrap;
  font-family:roboto;
  font-size: 1.5rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.9em;
  letter-spacing: .6px;
  margin-left:0px;
  
`;

const Stacker= styled.div`
  display: flex;
  flex-direction:row;
  height: auto;
  justify-content: space-around;
margin-top:64px;
  @media (max-width: 1130px) {
    flex-direction: column;
  }
`;
const Left = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  display:flex;
  justify-content:center;
`;

const Threat = styled.div`
    width:40vw;
  align-self:center;
  @media (max-width: 1130px) {
    width:85%;
  }
   @media (max-width: 768px) {
    width:100%;
  }
`;

const Right = styled.div`
    display:flex;
  justify-content:center;
`;

const Impacts = styled.div`
  width:40vw;

  justify-content:center;

    @media (max-width: 1130px) {
    width:85%;
  }
   @media (max-width: 768px) {
    width:100%;
  }
`;

const Contentwrapper = styled.div`
  margin-left:15px;
  margin-top:15px;
  margin-right:15px;
  margin-bottom:15px;

`;
const Scaleup = styled.div`
  transform: scale(1);
  @media (max-width: 768px) {
    transform: scale(1.09);
  }
`;

const Spacer = styled.div`
  margin-top:70px;
`;

const Carouselheader = styled.h2`

  font-family:roboto;
  font-size: 2rem;
  font-weight:400;
  color: #ffffff;
  margin: 0.4em 0em 0.7em;
  letter-spacing: .6px;
  margin-left:0px;
  
`;

const Impactwrapper = styled.div`
  margin-left:0px;
  margin-top:15px;
  margin-right:0px;
  margin-bottom:15px;
    transform: scale(1);
  transition: all 0.5s;
      &:hover {
  transform: scale(1.04);
    transition: all 0.5s;
  
}
`;


class Home extends Component{


askearth= ()=> {
          window.dexterApi.open();
          window.dexterApi.replyTo('how am i affected by climate change');
        }

  
  render(){


    
    return(
      
        <body>

          <SideMenuHome />
          <HomeBg/>
          
          

          <Stacker>
            
      <Contentwrapper>
          <Left>
           <Threat>  
           <Contentwrapper>
          <Tree>Home/</Tree>         
          </Contentwrapper>        
              <Impactwrapper><Link onClick={this.askearth}><InfoEarthnight/></Link></Impactwrapper>
           </Threat>
          </Left>
      </Contentwrapper>
     
      <Contentwrapper>
          <Right>
           <Impacts>
           <Carouselheader>EXPLORE</Carouselheader>
              <Scaleup><CarouselExplore/></Scaleup>            
           <Carouselheader>TRENDING</Carouselheader>
              <Scaleup><CarouselTrending/></Scaleup> 
              <Carouselheader>TAKE ACTION</Carouselheader>
              <Scaleup><CarouselActions/></Scaleup> 
              <Spacer/>

           </Impacts>
          </Right> 
      </Contentwrapper>

      </Stacker>
                  
          
        </body>
      
      );

  } 
}

export default Home;